var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3273_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8389 11.9944C21.5224 12.0916 21.9976 12.7245 21.9005 13.4079C21.6033 15.4979 20.6523 17.4403 19.1838 18.9568C17.7151 20.4731 15.8044 21.486 13.725 21.8501C11.6456 22.2143 9.50436 21.911 7.60789 20.9837C6.71669 20.5481 5.90103 19.9851 5.184 19.3171L4.13389 20.3673C3.34643 21.1548 2 20.597 2 19.4834V14.5H6.98341C8.09704 14.5 8.65475 15.8464 7.86729 16.6339L6.95325 17.5479C7.47507 18.0226 8.06441 18.4242 8.70594 18.7379C10.1283 19.4333 11.7342 19.6606 13.2938 19.3876C14.8533 19.1145 16.2864 18.3549 17.3877 17.2175C18.4893 16.0801 19.2025 14.6235 19.4254 13.056C19.5226 12.3725 20.1555 11.8972 20.8389 11.9944ZM16.3921 3.01622C17.2849 3.45269 18.1017 4.01686 18.8197 4.68631L19.8661 3.63991C20.6536 2.85245 22 3.41016 22 4.5238V9.50001H17.0238C15.9101 9.50001 15.3524 8.15359 16.1399 7.36614L17.0505 6.45551C16.5277 5.97933 15.9371 5.57656 15.2941 5.26216C13.8717 4.56678 12.2658 4.33933 10.7062 4.61243C9.14671 4.88551 7.71361 5.64514 6.6122 6.78249C5.51078 7.91983 4.79752 9.37656 4.57461 10.9441C4.47741 11.6275 3.84455 12.1028 3.16107 12.0056C2.47759 11.9084 2.00232 11.2755 2.09952 10.5921C2.39674 8.50208 3.34773 6.55978 4.81629 5.04331C6.28485 3.52685 8.19565 2.51402 10.275 2.1499C12.3544 1.78577 14.4956 2.08902 16.3921 3.01622Z",
    fill: "#B3261E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3273_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.66ec825178079dfe9fbd329ebaceac0a.svg";
export { ForwardRef as ReactComponent };